export enum AppTheme {
  BRK = 'BRK',
  CBB = 'CBB',
  '8DATA' = '8DATA',
}

const companyName = '8fig';

export default {
  BRK: {
    company: 'Berkeley Payments',
    copyright: `Berkeley Payment Solutions Powered by ${companyName}`,
    copyrightLink: '',
    logo: 'logos/berkeley-logo.png',
    logoWhite: 'logos/berkeley-logo.png',
    logoLeft: 12,
    logoHeight: 59,
    favicon: 'logos/brk-favicon.jpg',
    email: 'LoanSupport@Berkeleypayment.com',
    chatId: '1ej075a9i',
    displaySupportFooter: true,
    displaySupportBanner: false,
    googleTagManagerId: 'UA-7144444-5',
  },
  CBB: {
    company: companyName,
    copyright: companyName,
    copyrightLink: process.env.DOMAIN,
    logo: 'logos/8fig-logo.svg',
    logoWhite: 'logos/8fig-logo-cyan.svg',
    logoWhiteSmall: 'logos/8fig-logo-cyan.svg',
    logoCyan: 'logos/8fig-logo-cyan.svg',
    logoLeft: 0,
    logoHeight: 53,
    favicon: 'logos/8fig-favicon.jpg',
    email: 'service@8fig.co',
    chatId: 'default',
    displaySupportFooter: false,
    displaySupportBanner: true,
    googleTagManagerId: 'Not-set-up',
  },
  '8DATA': {
    company: '8Data',
    copyright: `8Data`,
    copyrightLink: process.env.DOMAIN,
    logo: 'logos/8data/8data-logo-white.svg',
    logoWhite: 'logos/8data/8data-logo-black.svg',
    logoWhiteSmall: 'logos/8data/8data-logo-white-small.svg',
    logoCyan: 'logos/8data/8data-logo-black.svg',
    logoLeft: 0,
    logoHeight: 53,
    favicon: 'logos/8data/8data-favicon.png',
    email: 'contact@8data.co',
    chatId: 'default',
    displaySupportFooter: false,
    displaySupportBanner: true,
    googleTagManagerId: 'Not-set-up',
  },
};
